import { fetchSVG } from '@global/SVGSprite';

export default {
  async load(url: string) {
    try {
      return await fetchSVG(url);
    } catch (error) {
      return Promise.reject(`[fetchSVG] ${error}`);
    }
  },
};
